import { i18nMark } from "@lingui/react";

import { DEVICE } from "base/constants";

import { getColorVariables } from "./color/generator.js";

export let ThemeList = [
  {
    Name: i18nMark("System default"),
    _id: "system_default"
  },
  {
    Name: i18nMark("Light"),
    _id: "light"
  },
  {
    Name: i18nMark("Dark"),
    _id: "dark"
  },
  {
    Name: i18nMark("Dim"),
    _id: "dim"
  }
];

export const applyAccountTheme = (
  colorCode,
  applyBackground = false,
  font,
  kind = DEVICE.WEB
) => {
  if (colorCode) {
    try {
      let [colorVariables] = getColorVariables(
        colorCode,
        applyBackground,
        font,
        kind
      );
      addStyleSheet(colorVariables);
    } catch (error) {
      console.info(error, "getColorVariables error");
    }
  }
};

export const removeExistingThemeClass = (themeList) => {
  themeList.forEach((theme) => {
    document.body.classList.remove(theme._id);
  });
};

export const onThemeChange = (value) => {
  const prefersDarkScheme = window.matchMedia("(prefers-color-scheme: dark)");
  // Remove Existing theme class Name
  removeExistingThemeClass(ThemeList);
  if (value === "system_default") {
    let themeValue = prefersDarkScheme.matches ? "dark" : "light";
    document.body.classList.add(themeValue);
  } else {
    document.body.classList.add(value);
  }
};

export function addStyleSheet(variables) {
  let themeVars = document.createTextNode(variables);

  let head = document.head;
  const style = Object.values(head.children).find(
    (item) => item.title === "custom-variables"
  );

  if (style) {
    style.textContent = "";
    style.appendChild(themeVars);
  } else {
    let newStyle = document.createElement("style");
    newStyle.setAttribute("title", "custom-variables");
    newStyle.appendChild(themeVars);
    head.appendChild(newStyle);
  }
}
